<app-header></app-header>

<section class="values" id="values">
    <div class="container aos-init aos-animate" data-aos="fade-up">
        <div class="row">
            <div class="col-lg-12">
                <br />
                <h1 class="text-center">Latest ParkUpp News</h1>
                <br />
            </div>
        </div>
        <div class="row">
            <div (click)="goToBlogPage(blog)" *ngFor="let blog of blogs" class="blog-clickable col-lg-4 mt-4 mt-lg-0 aos-init aos-animate px-5" data-aos="fade-up" data-aos-delay="600">
                <div class="box">
                    <ng-container *ngIf="blog.title">
                        <ng-container *ngIf="blog.blogImage">
                            <img alt="" class="img-fluid rounded" src="{{ blog.blogImage.largeUrl }}" />
                        </ng-container>
                        <h5 class="mt-4 mb-2 text-center">{{ blog.title }}</h5>
                        <p class="blog-summary">{{ GlobalService.stripHtml(blog.body | truncate: [180, '...']) }}</p>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <br />
    <br />
</section>

<app-footer></app-footer>
